import { useEffect } from 'react';
import { useSignalRHubStore } from '../stores/useSignalR';
import { ProfileSignalRQueryOperation } from '../types/api/profile';
import { useAuth } from './auths/useAuthService';

export const useSignalRHub = (
  hubName: string,
  url: string,
  method: ProfileSignalRQueryOperation,
) => {
  const { getAccessToken } = useAuth();

  const initializeHub = useSignalRHubStore((state) => state.initializeHub);
  const setStreamMethod = useSignalRHubStore((state) => state.setStreamMethod);
  const setStreamArgs = useSignalRHubStore((state) => state.setStreamArgs);
  const cleanUpHubConnection = useSignalRHubStore((state) => state.cleanUpHubConnection);

  useEffect(() => {
    if (getAccessToken()) {
      initializeHub(hubName, url, getAccessToken).then(() => {
        setStreamMethod(hubName, method);
      });
    }
    return () => {
      cleanUpHubConnection(hubName).then(() => {
        console.log(`${hubName} SignalR Connection Cleared`);
      });
    };
  }, [hubName, url, method, initializeHub, cleanUpHubConnection, setStreamMethod, getAccessToken]);

  return { setStreamMethod, setStreamArgs };
};
